import React from 'react';
import SelectionList from '../../selectionList/SelectionList';
import FilterValueList from './FilterValueList';
import {findConditionIndex} from './util';
import { getCurrentResource } from '../../../util/tools';
import { getRefList, setRefList } from '../../../util/localStorage';
import { performApiRequest, REFLIST_IS_ACTUAL_API_URL, REFLIST_LOAD_API_URL} from '../../../util/restapi';

import {
	CONDITION_NONE,
	CONDITION_IS_NOT_NULL,
	CONDITION_IS_NULL,
	CONDITION_INCLUDE,
	CONDITION_NOT_INCLUDE,
} from './util';

const INIT_STATE_STARTED = 'started';
const INIT_STATE_ERROR = 'error';
const INIT_STATE_COMPLETE = 'complete';

class FilterObjectRefList extends React.Component {

	classId = null;
	listId = null;
	items = [];

	/*
		props:
			filter
			filterIndex
			holder
			rateView
			handleFilterChanged
	*/
	constructor(props) {
		super(props);
		props.holder.registerFilterComponent(this, props.filterIndex); 
		this.refConditionList = React.createRef();
		this.resCondition = getCurrentResource().components.rateview.conditions.conditions;
		this.conditions = [
			{id: CONDITION_NONE, title: this.resCondition.none.title},
		];
		let filter = props.filter;
		for(let conditionId of filter.filterModel.listConditions) {
			this.conditions.push(
				{id: conditionId, title: this.resCondition[conditionId].title}
			);
		}
		this.classId = filter.filterModel.refClassId;
		this.listId = filter.filterModel.refListId;
		if( this.listId == undefined || this.listId == null )
			this.listId = '';
		
		let conditionIndex = findConditionIndex(this.conditions, filter.conditionId, 0);
		this.state = {
			filter: props.filter,
			conditionIndex: conditionIndex
		}
	}
	componentDidMount = async () => {
		if( ! this.classId ) {
			this.initErrorMessage = 'Undefined classId';
			this.setState( { initState: INIT_STATE_ERROR} );
			return;
		}
		let classId = this.classId;
		let listId = this.listId;
		let list = getRefList(classId, listId);
		if( list != null ) {
			let request = {classId: classId, listId: listId, createTime: list.createTime};
			let response = await performApiRequest( REFLIST_IS_ACTUAL_API_URL, request );
			if( ! response.success ) {
				this.initErrorMessage = response.message;
				this.setState( { initState: INIT_STATE_ERROR} );
				return;
			}
			if( ! response.data )
				list = null;
		}
		if( list == null ) {
			let request = {classId: classId, listId: listId};
			let response = await performApiRequest( REFLIST_LOAD_API_URL, request );
			if( ! response.success ) {
				this.initErrorMessage = response.message;
				this.setState( { initState: INIT_STATE_ERROR} );
				return;
			}
			list = response.data;
			setRefList(classId, listId, list);
		}
		for(let ref of list.list) {
			this.items.push( {id: ref.globalId, title: ref.card} )
		}

		this.listReferences = [{id: 0, globalId: '', card: this.resource.noCondition}, ...list.list];
		this.setState({initState: INIT_STATE_COMPLETE});
	}
	updateFilter = (filter) => {
		let conditionIndex = findConditionIndex(this.conditions, filter.conditionId, 0);
		this.refConditionList.current.setSelectedIndex( conditionIndex );
		this.setState({filter: filter, conditionIndex: conditionIndex});
	}
	
	handleConditionSelection = (index) => {
		if( index == -1 )
			index = 0;
		let cond = this.conditions[index];
		this.props.filter.conditionId = cond.id;
		this.setState({conditionIndex: index}, this.handleFilterChanged);
	}	
	handleFilterChanged = (filter) => {
		if( ! filter )
			filter = this.props.filter;

		if( filter.conditionId == CONDITION_NONE ) {
			filter.active = false;
			filter.bodyText = '';
		} else if( filter.conditionId == CONDITION_IS_NOT_NULL || filter.conditionId == CONDITION_IS_NULL ) {
			filter.active = true;
			filter.bodyText = filter.title + ' ' + this.resCondition[filter.conditionId].title;
		} else if( filter.conditionId == CONDITION_INCLUDE || filter.conditionId == CONDITION_NOT_INCLUDE ) {
			if( filter.listValue.length == 0 ) {
				filter.active = false;
				filter.bodyText = '';
			} else {
				filter.active = true;
				filter.bodyText = filter.title + ' ' + this.resCondition[filter.conditionId].title + ' ( ';
				let first = true;
				for(let itemId of filter.listValue) {
					for(let item of this.items) {
						if(itemId == item.id) {
							if( first )
								first = false;
							else
								filter.bodyText += ', ';
							filter.bodyText += "'" + item.title + "'";
							break;
						}
					}
				}
				filter.bodyText += ' )';
			}
		}
		
		this.props.handleFilterChanged( filter );
	}
	
	render() {
		if( this.state.initState == INIT_STATE_STARTED ) {
			return (
				<div style={{textAlign: 'center', padding: '50px'}}>
					...
				</div>
			);
		} else if( this.state.initState == INIT_STATE_ERROR ) {
			return (
				<div style={{textAlign: 'center', padding: '50px', color: 'red'}}>
					{this.initErrorMessage}
				</div>
			);
		} 

		return (
			<div style={{display: 'flex'}}>
				<div style={{width: '250px', border: '1px solid black'}}>
					<SelectionList 
						ref={this.refConditionList}
						items={this.conditions} 
						handleItemSelection={this.handleConditionSelection}
						selectedIndex={this.state.conditionIndex} 
					/>
				</div>
				<div style={{flexGrow: '100', marginLeft: '10px'}}>
					<FilterValue holder={this} />
				</div>
			</div>
		);
	}
}

function FilterValue(props) {
	let holder = props.holder;
	let cond = holder.conditions[ holder.state.conditionIndex ];
	if( cond.id == 'include' || cond.id == 'notInclude') {
		return <FilterValueList items={holder.items} filter={holder.props.filter} handleFilterChanged={holder.handleFilterChanged}/>
	} else {
		return null;
	}
}

export default FilterObjectRefList;
